// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARTICLES_TITLE = "\u010cl\u00e1nky";
export const STROLLEROPEDIA_NEW_ARTICLES_LONG = "Nejnov\u011bj\u0161\u00ed \u010dl\u00e1nky v ko\u010d\u00e1rkopedii";
export const STROLLER_STROLLEROPEDIA = "Ko\u010d\u00e1rkopedie";
